import styled from 'styled-components'

export const Wrapper = styled.article`
  position: absolute;
  min-width: 104px;
  max-height: 87px;

  background: #ffffff;
  box-shadow: 0px 3px 8px rgba(3, 47, 31, 0.12);
  border-radius: 10px;
  right: 2rem;
  top: -0.8rem;
`

export const Button = styled.button`
  padding: 0.5rem;
  background-color: #ffffff;
  outline: none;
  border: none;
  text-align: center;
  width: 100%;
  border-radius: inherit;
  color: #ea3e08;
  font-family: 'Inter';
  font-weight: 600;
  cursor: pointer;
`
